module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('bottom-toolbar'), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly"
  }, [_c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.addNewGroup
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.isInViewMode === false) ? _c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "New Team",
      "ReturnButton": "",
      "menuAccess": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInViewMode === true) ? _c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": 'Team: ' + _vm.labelTeam,
      "ReturnButton": "",
      "menuAccess": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rowBackgroundImage",
    staticStyle: {
      "height": "126px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('h4', {
    staticClass: "page-title"
  }, [_c('i', {
    staticClass: "icon fa fa-users"
  }), _vm._v(" "), (_vm.isInViewMode === false) ? _c('label', [_vm._v(_vm._s(_vm.$t('businessMembers.add_team')))]) : _vm._e(), _vm._v(" "), (_vm.isInViewMode === true) ? _c('label', [_vm._v(_vm._s(_vm.$t('common.team_label')) + ": " + _vm._s(_vm.labelTeam) + " ")]) : _vm._e()]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('businessMembers.team_name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.labelTeam),
      expression: "labelTeam"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "inherit"
    },
    attrs: {
      "type": "text",
      "placeholder": "Team name"
    },
    domProps: {
      "value": (_vm.labelTeam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.labelTeam = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.email_notification')))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('div', {
    staticClass: "form-group col"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-radio custom-control-inline"
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "radio",
      "id": "radioemail1",
      "name": "radioEmail",
      "value": "NO",
      "title": "No"
    },
    domProps: {
      "checked": _vm.isEmailContact === 'NO'
    },
    on: {
      "change": function($event) {
        _vm.isEmailContact = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "radioemail1"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no_label')))])]), _vm._v(" "), _c('div', {
    staticClass: "custom-control custom-radio custom-control-inline"
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "radio",
      "id": "radioemail2",
      "name": "radioEmail",
      "value": "YES",
      "title": "Yes"
    },
    domProps: {
      "checked": _vm.isEmailContact === 'YES'
    },
    on: {
      "change": function($event) {
        _vm.isEmailContact = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "radioemail2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes_label')))])])])])])]), _vm._v(" "), (_vm.isEmailContact === 'YES') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.eml_adrs')))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailNotification),
      expression: "emailNotification"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "inherit"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.emailaddressLabel
    },
    domProps: {
      "value": (_vm.emailNotification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailNotification = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isEmailContact === 'YES') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.min_amount')))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountNotification),
      expression: "amountNotification"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "inherit"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.amountLabel
    },
    domProps: {
      "value": (_vm.amountNotification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amountNotification = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.hasGroups) ? _c('div', {
    staticClass: "row headerGroupList showLargeScreenOnly"
  }, [_c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_vm._v("Layer")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label label-left"
  }, [_vm._v("Group Name")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 col-form-label"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label label-left"
  }, [_vm._v("Members")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 col-form-label"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 col-form-label",
    staticStyle: {
      "padding-left": "22px"
    }
  }, [_vm._v("Visibility")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v("Remove")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v("Group Actions")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedArray), function(group, index) {
    return (!_vm.isSmartphone) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "groupDiv showLargeScreenOnly row"
    }, [_c('div', {
      staticClass: "arrow-box col-1 col-md-1"
    }, [_c('div', {
      staticClass: "row"
    }, [(index === 0) ? _c('i', {
      staticClass: "icon icon-arrow-disabled icon-arrow-sort icon-arrow-sort-up fa fa-caret-up"
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.upGroupLevel(group.label)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-sort icon-arrow-sort-up fa fa-caret-up"
    })]) : _vm._e()]), _vm._v(" "), _c('label', {
      staticClass: "lvl-group row"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(index < _vm.sortedArray.length - 1) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.lowerGroupLevel(group.label)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down"
    })]) : _vm._e(), _vm._v(" "), (index >= _vm.sortedArray.length - 1) ? _c('i', {
      staticClass: "icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down icon-arrow-disabled"
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row col-md-11 groupDivContainers"
    }, [_c('div', {
      staticClass: "leftGroupDiv col-md-2"
    }, [_c('label', {
      staticClass: "col-form-label label-group longword-word"
    }, [_c('b', [_vm._v(_vm._s(group.label))])])]), _vm._v(" "), _c('div', {
      staticClass: "rightGroupDiv col-md-8"
    }, _vm._l((group.members), function(member, index) {
      return _c('div', {
        key: index,
        staticClass: "row"
      }, [_c('label', {
        staticClass: "col-7 col-md-7 longword-word"
      }, [_vm._v(_vm._s(member.identifier))]), _vm._v(" "), _c('swatches', {
        staticClass: "col-2 col-md-2",
        attrs: {
          "trigger-style": {
            width: '20px',
            height: '20px'
          },
          "colors": _vm.colors,
          "row-length": "5",
          "shapes": "squares",
          "popover-to": "right",
          "swatch-size": "20"
        },
        on: {
          "open": function($event) {
            return _vm.setCurrentMemberModifyVisibility(group.label, index)
          },
          "close": function($event) {
            return _vm.setMemberVisibility($event)
          }
        },
        model: {
          value: (_vm.membersColor[member.index]),
          callback: function($$v) {
            _vm.$set(_vm.membersColor, member.index, $$v)
          },
          expression: "membersColor[member.index]"
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "col-1 col-md-1",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            return _vm.removeMemberFromGroup(group.label, member.identifier)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-delete-member fa fa-times"
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-1 col-md-1"
      })], 1)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "actionGroupDiv col-md-2",
      class: _vm.colorBottomButton
    }, [_c('div', {
      staticClass: "row"
    }, [_c('a', {
      staticClass: "button-action button-delete-group",
      attrs: {
        "href": "/accountMembers/addMemberGroupMembersList/"
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentGroupNumber(group.label)
        }
      }
    }, [_c('f7-icon', {
      staticClass: "smallIcons",
      attrs: {
        "f7": "add"
      }
    }), _vm._v("\n                          " + _vm._s(_vm.$t('businessMembers.add_member_small')) + "\n                        ")], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('button', {
      staticClass: "button-action button-delete-group",
      attrs: {
        "round": "",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteGroup(group.label)
        }
      }
    }, [_c('f7-icon', {
      staticClass: "smallIcons",
      attrs: {
        "f7": "trash"
      }
    }), _vm._v("\n                            " + _vm._s(_vm.$t('businessMembers.rm_group')) + "\n                        ")], 1)])])])]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly row"
    }, [_c('div', {
      staticClass: "arrow-box col-1"
    }, [_c('a', {
      staticClass: "row",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.upGroupLevel(group.label)
        }
      }
    }, [(index === 0) ? _c('i', {
      staticClass: "icon icon-arrow-disabled icon-arrow-sort icon-arrow-sort-up fa fa-caret-up"
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('i', {
      staticClass: "icon icon-arrow-sort icon-arrow-sort-up fa fa-caret-up"
    }) : _vm._e()]), _vm._v(" "), _c('label', {
      staticClass: "lvl-group row"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
      staticClass: "row",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.lowerGroupLevel(group.label)
        }
      }
    }, [(index < _vm.sortedArray.length - 1) ? _c('i', {
      staticClass: "icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down"
    }) : _vm._e(), _vm._v(" "), (index >= _vm.sortedArray.length - 1) ? _c('i', {
      staticClass: "icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down icon-arrow-disabled"
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card col-10"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('label', {
      staticClass: "col-form-label label-group longword-word"
    }, [_c('b', [_vm._v(_vm._s(group.label))])])]), _vm._v(" "), _vm._l((group.members), function(member, index) {
      return _c('div', {
        key: index,
        staticClass: "row mobile-card-body"
      }, [_c('label', {
        staticClass: "col-7 col-md-7 longword-word emailsize"
      }, [_vm._v(_vm._s(member.identifier))]), _vm._v(" "), _c('swatches', {
        staticClass: "col-2 col-md-2",
        attrs: {
          "trigger-style": {
            width: '20px',
            height: '20px'
          },
          "colors": _vm.colors,
          "row-length": "5",
          "shapes": "squares",
          "popover-to": "right",
          "swatch-size": "20"
        },
        on: {
          "open": function($event) {
            return _vm.setCurrentMemberModifyVisibility(group.label, index)
          },
          "close": function($event) {
            return _vm.setMemberVisibility($event)
          }
        },
        model: {
          value: (_vm.membersColor[member.index]),
          callback: function($$v) {
            _vm.$set(_vm.membersColor, member.index, $$v)
          },
          expression: "membersColor[member.index]"
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "col-1 col-md-1",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            return _vm.removeMemberFromGroup(group.label, member.identifier)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-delete-member fa fa-times"
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-1 col-md-1"
      })], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "card-footer",
      class: _vm.colorBottomButton
    }, [_c('a', {
      staticClass: "button-action button-delete-group btn-mobile-footer",
      attrs: {
        "href": "/accountMembers/addMemberGroupMembersList/"
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentGroupNumber(group.label)
        }
      }
    }, [_c('f7-icon', {
      staticClass: "smallIcons",
      attrs: {
        "f7": "add"
      }
    }), _vm._v("\n                        " + _vm._s(_vm.$t('businessMembers.add_member_small')) + "\n                      ")], 1), _vm._v(" "), _c('button', {
      staticClass: "button-action button-delete-group btn-mobile-footer",
      attrs: {
        "round": "",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteGroup(group.label)
        }
      }
    }, [_c('f7-icon', {
      staticClass: "smallIcons",
      attrs: {
        "f7": "trash"
      }
    }), _vm._v("\n                        " + _vm._s(_vm.$t('businessMembers.rm_group')) + "\n                      ")], 1)])], 2)])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "groupDiv row justify-content-end",
    class: _vm.colorBottomButton
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton buttonAccordionForm longword-word",
    staticStyle: {
      "margin-bottom": "1rem"
    },
    on: {
      "click": _vm.addNewGroup
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('businessMembers.add_group')) + "\n                ")])], 1)], 2)])])]), _vm._v(" "), (_vm.isInViewMode === false) ? _c('div', {
    staticClass: "md"
  }, [_c('div', {
    staticClass: "row justify-content-start",
    class: _vm.colorBottomButton
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "button-action",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.addTeam()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v(" "), _c('span', [_vm._v("Save")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isInViewMode === true) ? _c('div', [_c('div', {
    staticClass: "row justify-content-start",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "offset-md-2 col-md-3 height-button"
  }, [_c('button', {
    staticClass: "button-action",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteTeam()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-trash"
  }), _vm._v(" "), _c('span', [_vm._v("Delete Team")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 height-button"
  }, [_c('button', {
    staticClass: "button-action",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.editTeam()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v(" "), _c('span', [_vm._v("Apply changes")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offset-md-5 col-md-3"
  }, [_c('a', {
    attrs: {
      "href": "/accountMembers/"
    }
  }, [_c('button', {
    staticClass: "button-action",
    attrs: {
      "round": ""
    }
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" "), _c('span', [_vm._v("Cancel")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 height-button"
  }, [_c('a', {
    attrs: {
      "href": "/accountMembers/"
    }
  }, [_c('button', {
    staticClass: "button-action",
    attrs: {
      "round": ""
    }
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" "), _c('span', [_vm._v("Cancel")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0473f684", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0473f684","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/accounts/CMAddTeam.vue
// module id = 1610
// module chunks = 2